"use client";

import { Typography } from "@/components/ui/typography";
import type { AboutUsHumanConnectionProps } from "./types";
import { aboutUsHumanConnectionData } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Icon from "@/components/ui/Icon";

const AboutUsHumanConnection = ({ className }: AboutUsHumanConnectionProps) => {
  const { card, items } = aboutUsHumanConnectionData;

  return (
    <section className={cn("section bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="ng-white grid grid-cols-1 place-content-start rounded-3xl lg:rounded-2xl md:gap-4 md:grid-cols-3 md:p-4 overflow-hidden border border-neutral-200 md:border-neutral-200">
          <div className="flex flex-col md:grid md:grid-cols-2 md:gap-8 md:col-span-3">
            <div className="flex md:order-2 md:rounded-2xl overflow-hidden relative">
              <Image
                alt={card.title}
                src={card.imageUrl}
                width={1056}
                height={581}
                className="w-full h-full object-left-top object-cover md:object-center"
              />
            </div>
            <div className="grid grid-cols-1 place-content-start md:place-content-center pt-5 pb-6 px-5 gap-2 md:p-4 md:gap-6 place-content-start flex-auto text-semantic-text-primary">
              <Typography
                variant="titleMd"
                asChild
                className="font-semibold lg:text-[40px] lg:font-medium lg:leading-[150%] lg:text-gray-800"
              >
                <h4>{card.title}</h4>
              </Typography>
              <div className="text-base leading-[163%] lg:text-gray-700 lg:leading-[150%] lg:max-w-[460]">
                <p>{card.description}</p>
              </div>
            </div>
          </div>
          {items?.map(({ title, iconId, description }, i) => {
            return (
              <div
                key={i}
                className="flex gap-3 px-5 text-base md:p-5 leading-[160%] md:text-sm md:leading-[150%]"
              >
                <div className="grid grid-cols-1 place-content-start gap-3 flex-auto min-w-0 text-gray-800 py-6 md:p-0 border-t border-t-neutral-100 md:border-0">
                  {(!!iconId || !!title) && (
                    <div className="flex items-center gap-2 md:flex-col md:items-start md:gap-3">
                      {!!iconId && (
                        <Icon
                          id={iconId}
                          width={64}
                          height={64}
                          className="w-12 h-12 shrink-0 md:w-16 md:h-16"
                        />
                      )}
                      {!!title && (
                        <Typography variant="titleMd" className="md:font-semibold">
                          <h4>{title}</h4>
                        </Typography>
                      )}
                    </div>
                  )}
                  {!!description && (
                    <div>
                      <p className="text-semantic-text-primary lg:text-gray-800">
                        {description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUsHumanConnection);
